// extracted by mini-css-extract-plugin
module.exports = {"Form":"Register_Form__82s-k","FormLabel":"Register_FormLabel__2q0MN","FormWrapper":"Register_FormWrapper__I4Xc4"};